import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MinusIcon, PlusIcon } from "../../../assets/svg/ProuductIcons";
import { usePartner } from "../../../helpers/BrandPageAPI";

const MobileNavMenu = ({ categoryData, collectionData }) => {
  const { partnerData } = usePartner();
  const cartLogoColor = partnerData?.StoreColor;
  const customerCodeStore = useParams();
  const customerCode = customerCodeStore?.UserCode;
  const [openMenus, setOpenMenus] = useState([]);

  const toggleSubMenu = (menu) => {
    setOpenMenus((prev) =>
      prev.includes(menu) ? prev.filter((m) => m !== menu) : [...prev, menu]
    );
  };

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul className="drawer_links_con">
        {/* jewelry menu */}
        <li
          className={`submenu_main_con ${openMenus.includes("jewelry") ? "active" : ""
            }`}
        >
          <button
            className="mobile_menu_item submenu-toggle"
            onClick={() => toggleSubMenu("jewelry")}
          >
            <span style={{ color: cartLogoColor }}>Jewelry</span>
            <span className="icon_con">
              <PlusIcon className="plus_icon" style={{ color: cartLogoColor }} />
              <MinusIcon className="minus_icon" style={{ color: cartLogoColor }} />
            </span>
          </button>
          <div className="submenu_inner_con">
            <div className="submenu_overflow_con">
              <ul>
                {categoryData?.Data &&
                  categoryData.Data.map((category, index) => (
                    <li key={index}>
                      <Link
                        to={`/${customerCode}/category/${category.GatiCategoryId}`}
                        className="is_link"
                        style={{ color: cartLogoColor }}
                      >
                        {category.DesgGroupName}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </li>

        {/* Collection menu */}
        <li
          className={`submenu_main_con ${openMenus.includes("collection") ? "active" : ""
            }`}
        >
          <button
            className="mobile_menu_item submenu-toggle"
            onClick={() => toggleSubMenu("collection")}
          >
            <span style={{ color: cartLogoColor }}>Collection</span>
            <span className="icon_con">
              <PlusIcon className="plus_icon" />
              <MinusIcon className="minus_icon" />
            </span>
          </button>
          <div className="submenu_inner_con">
            <div className="submenu_overflow_con">
              <ul>
                {collectionData?.Data &&
                  collectionData.Data.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={`/${customerCode}/collection/${item.GatiCategoryId}`}
                        className="is_link"
                        style={{ color: cartLogoColor }}
                      >
                        {item.DesgGroupName}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </li>
        <li>
          <Link to={`/${customerCode}/connectUs`} className="mobile_menu_item is_link" style={{ color: cartLogoColor }}>
            {/* Contact */}
            Connect Us
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
